const COMPASS_POINTS = [
  "N",
  "NNE",
  "NE",
  "ENE",
  "E",
  "ESE",
  "SE",
  "SSE",
  "S",
  "SSW",
  "SW",
  "WSW",
  "W",
  "WNW",
  "NW",
  "NNW",
] as const;

/**
 * Converts millidegrees to a human-readable bearing string.
 * Example: 90000 → "90° E"
 */
export function formatCompassBearing(millidegrees: number | null): string | null {
  if (millidegrees === null) return null;

  const degrees = Math.round(millidegrees / 1000);
  const normalized = ((degrees % 360) + 360) % 360;
  const index = Math.round(normalized / 22.5) % 16;
  const compass = COMPASS_POINTS[index];

  return `${String(normalized)}° ${compass ?? ""}`;
}
